export default "__VITE_ASSET__DU2VPa4O__"